import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/layout/Partials/Header';

import TextFieldGroup from 'components/common/TextFieldGroup';
import {
    getThemeAction,
    updateThemeAction,
} from 'redux/actions/themeActions';
import { resetErrors } from 'redux/actions/errorsActions';
import Loading from 'components/common/Loading';
import { withStyles } from '@material-ui/styles';
import { Theme } from 'utils/Theme';
import AdminLayout from 'components/layout/AdminLayout';
import { Box } from '@material-ui/core';
import Section from 'components/UI/Section';
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import isEmpty from 'utils/is-empty';

const styles = Theme();
const isValidHex = (hex) => {
    const patten = new RegExp(/^#[0-9A-F]{6}$/i);
    const testResult = patten.test(hex);
    return testResult;
};

const validationSchema = Yup.object().shape({
    primary: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
    secondary: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
    info: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
    success: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
    warning: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
    danger: Yup.string('Invalid color')
        .required('Required')
        .length(7, 'Invalid color')
        .test('is-hex', 'Invalid color', (value) => isValidHex(value)),
});

const ThemeSettings = ({
    loading,
    history,
    getThemeAction,
    classes,
    updateThemeAction,
    auth,
    errors,
    theme,
    resetErrors,
}) => {
    const [currentTheme, setCurrentTheme] = useState({});
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    console.log(loading, theme);

    // //COMPONENT MOUNT
    useEffect(() => {
        getThemeAction();
    }, []);

    //COMPONENT RECIEVED NEW THEME PROPS
    useEffect(() => {
        if (!isEmpty(theme)) {
            setCurrentTheme(theme);
            setIsInitialLoading(false);
        }
    }, [theme]);

    const onSubmit = (values) => {
        updateThemeAction(values);
    };

    const { primary, secondary, info, success, danger, warning } =
        currentTheme ?? {};

    return (
        <AdminLayout>
            <Helmet>
                <title>Appearance</title>
            </Helmet>
            <Box className={'u-m-zero'}>
                <Header>
                    <h2 className="c-navbar__title">Theme Settings</h2>
                </Header>
                {!loading && !isInitialLoading && (
                    <Box className="u-m-xsmall">
                        <Section>
                            <div className={'u-p-small full_height'}>
                                <div className="o-line ">
                                    <h3
                                        className={`${classes.colorPrimary} u-text-capitalize u-pt-zero u-mt-zero u-pb-small`}
                                    >
                                        Site colour theme settings
                                    </h3>
                                    <div>
                                        <button
                                            onClick={() => {
                                                history.goBack();
                                            }}
                                            className={`u-mr-xsmall c-btn ${classes.buttonSecondary} u-mb-medium`}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                                <hr className="u-mt-small u-mb-medium" />
                                <Formik
                                    initialValues={currentTheme}
                                    validationSchema={validationSchema}
                                    onSubmit={(values) => onSubmit(values)}
                                >
                                    {({
                                        handleChange,
                                        errors,
                                        values,
                                        handleSubmit,
                                    }) => (
                                        <div className="row">
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Primary'}
                                                    onChange={handleChange(
                                                        'primary'
                                                    )}
                                                    name={'primary'}
                                                    value={values.primary}
                                                    error={errors.primary || ''}
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Secondary'}
                                                    onChange={handleChange(
                                                        'secondary'
                                                    )}
                                                    name={'secondary'}
                                                    value={values.secondary}
                                                    error={
                                                        errors.secondary || ''
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Warning'}
                                                    onChange={handleChange(
                                                        'warning'
                                                    )}
                                                    name={'warning'}
                                                    value={values.warning}
                                                    error={errors.warning || ''}
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Success'}
                                                    onChange={handleChange(
                                                        'success'
                                                    )}
                                                    name={'success'}
                                                    value={values.success}
                                                    error={errors.success || ''}
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Info'}
                                                    onChange={handleChange(
                                                        'info'
                                                    )}
                                                    name={'info'}
                                                    value={values.info}
                                                    error={errors.info || ''}
                                                />
                                            </div>
                                            <div
                                                className={'col-sm-6 col-lg-4'}
                                            >
                                                <TextFieldGroup
                                                    label={'Error'}
                                                    onChange={handleChange(
                                                        'danger'
                                                    )}
                                                    name={'danger'}
                                                    value={values.danger}
                                                    error={errors.danger || ''}
                                                />
                                            </div>
                                            <div
                                                className={
                                                    'col-sm-12 u-text-right'
                                                }
                                            >
                                                <button
                                                    onClick={handleSubmit}
                                                    className={clsx(
                                                        classes.buttonPrimary,
                                                        !isEmpty(errors) &&
                                                            'is-disabled',
                                                        `c-btn  has-arrow u-text-center`
                                                    )}
                                                >
                                                    Save Colour Scheme
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </Formik>

                                <hr className="u-mt-small u-mb-medium" />
                                <h4
                                    className={`${classes.colorPrimary} u-text-capitalize u-pt-zero u-mt-zero`}
                                >
                                    Theme Preview
                                </h4>
                                <p className={'u-mb-small'}>
                                    <i>Save theme to preview changes.</i>
                                </p>

                                <h5>Text</h5>
                                <div className={'u-mt-small u-mb-small'}>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: primary }}
                                    >
                                        This is a primary text
                                    </h6>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: secondary }}
                                    >
                                        This is a secondary text
                                    </h6>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: info }}
                                    >
                                        This is a info text
                                    </h6>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: success }}
                                    >
                                        This is a success text
                                    </h6>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: danger }}
                                    >
                                        This is a danger text
                                    </h6>
                                    <h6
                                        className={'u-mr-small'}
                                        style={{ color: warning }}
                                    >
                                        This is a warning text
                                    </h6>
                                </div>

                                <h5>Badges</h5>

                                <div className={'u-mt-small u-mb-small'}>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: primary,
                                            color: primary,
                                        }}
                                    >
                                        Badge Primary{' '}
                                    </span>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: secondary,
                                            color: secondary,
                                        }}
                                    >
                                        Badge Secondary{' '}
                                    </span>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: info,
                                            color: info,
                                        }}
                                    >
                                        Badge Info
                                    </span>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: success,
                                            color: success,
                                        }}
                                    >
                                        Badge Success{' '}
                                    </span>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: danger,
                                            color: danger,
                                        }}
                                    >
                                        Badge Danger{' '}
                                    </span>
                                    <span
                                        className={'c-badge u-mr-small'}
                                        style={{
                                            borderColor: warning,
                                            color: warning,
                                        }}
                                    >
                                        Badge Warning
                                    </span>
                                </div>

                                <h5>Buttons</h5>
                                <div className={'u-mt-small u-mb-small'}>
                                    <button
                                        className={clsx(
                                            'btn  u-mr-small',
                                            classes.buttonPrimary
                                        )}
                                        style={{ background: primary }}
                                    >
                                        Button Primary
                                    </button>
                                    <button
                                        className={clsx(
                                            'btn  u-mr-small',
                                            classes.buttonSecondary
                                        )}
                                    >
                                        Button Secondary
                                    </button>
                                    <button
                                        className={clsx(
                                            classes.buttonInfo,
                                            'btn u-mr-small'
                                        )}
                                    >
                                        Button Info
                                    </button>
                                    <button
                                        className={clsx(
                                            classes.buttonSuccess,
                                            'btn u-mr-small'
                                        )}
                                    >
                                        Button Success
                                    </button>
                                    <button
                                        className={clsx(
                                            'btn  u-mr-small',
                                            classes.buttonWarning
                                        )}
                                    >
                                        Button Warning
                                    </button>
                                    <button
                                        className={clsx(
                                            'btn  u-mr-small',
                                            classes.buttonDanger
                                        )}
                                    >
                                        Button Danger
                                    </button>
                                </div>
                            </div>
                        </Section>
                    </Box>
                )}
                {loading && <Loading />}
            </Box>
        </AdminLayout>
    );
};

ThemeSettings.propTypes = {
    auth: PropTypes.object.isRequired,
    getThemeAction: PropTypes.func,
    updateThemeAction: PropTypes.func,
    resetErrors: PropTypes.func,
    theme: PropTypes.object,
    errors: PropTypes.object,
    classes: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    theme: state?.theme?.palette,
    errors: state.errors,
    loading: state?.theme?.loading,
});

export default connect(mapStateToProps, {
    getThemeAction,
    updateThemeAction,
    resetErrors,
})(withRouter(withStyles(styles)(ThemeSettings)));
